import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex flex-row justify-evenly flex-wrap w-full py-4 px-2 text-center items-center"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_10 = ["href"];
const _hoisted_11 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_16 = ["href"];
const _hoisted_17 = {
  class: "diamond-clip-path diamond-icon"
};
const _hoisted_18 = ["href"];
const _hoisted_19 = ["href"];
const _hoisted_20 = {
  class: "diamond-clip-path diamond-icon"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  return _openBlock(), _createElementBlock("ul", _hoisted_1, [_ctx.socials.github ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: _ctx.socials.github,
    target: "_blank",
    ref: "github"
  }, [_createElementVNode("li", _hoisted_3, [_createVNode(_component_svg_icon, {
    "icon-class": "github",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_2)) : _createCommentVNode("v-if", true), _ctx.socials.twitter ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    href: _ctx.socials.twitter,
    target: "_blank",
    ref: "twitter"
  }, [_createElementVNode("li", _hoisted_5, [_createVNode(_component_svg_icon, {
    "icon-class": "twitter",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_4)) : _createCommentVNode("v-if", true), _ctx.socials.stackoverflow ? (_openBlock(), _createElementBlock("a", {
    key: 2,
    href: _ctx.socials.stackoverflow,
    target: "_blank",
    ref: "stackoverflow"
  }, [_createElementVNode("li", _hoisted_7, [_createVNode(_component_svg_icon, {
    "icon-class": "stackoverflow",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_6)) : _createCommentVNode("v-if", true), _ctx.socials.wechat ? (_openBlock(), _createElementBlock("a", {
    key: 3,
    href: _ctx.socials.wechat,
    target: "_blank",
    ref: "wechat"
  }, [_createElementVNode("li", _hoisted_9, [_createVNode(_component_svg_icon, {
    "icon-class": "wechat",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_8)) : _createCommentVNode("v-if", true), _ctx.socials.qq ? (_openBlock(), _createElementBlock("a", {
    key: 4,
    href: _ctx.socials.qq,
    target: "_blank",
    ref: "qq"
  }, [_createElementVNode("li", _hoisted_11, [_createVNode(_component_svg_icon, {
    "icon-class": "qq",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_10)) : _createCommentVNode("v-if", true), _ctx.socials.weibo ? (_openBlock(), _createElementBlock("a", {
    key: 5,
    href: _ctx.socials.weibo,
    target: "_blank",
    ref: "weibo"
  }, [_createElementVNode("li", _hoisted_13, [_createVNode(_component_svg_icon, {
    "icon-class": "weibo",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_12)) : _createCommentVNode("v-if", true), _ctx.socials.csdn ? (_openBlock(), _createElementBlock("a", {
    key: 6,
    href: _ctx.socials.csdn,
    target: "_blank",
    ref: "csdn"
  }, [_createElementVNode("li", _hoisted_15, [_createVNode(_component_svg_icon, {
    "icon-class": "csdn",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_14)) : _createCommentVNode("v-if", true), _ctx.socials.zhihu ? (_openBlock(), _createElementBlock("a", {
    key: 7,
    href: _ctx.socials.zhihu,
    target: "_blank",
    ref: "zhifu"
  }, [_createElementVNode("li", _hoisted_17, [_createVNode(_component_svg_icon, {
    "icon-class": "zhifu",
    class: "fill-current"
  })])], 8 /* PROPS */, _hoisted_16)) : _createCommentVNode("v-if", true), _ctx.socials.juejin ? (_openBlock(), _createElementBlock("a", {
    key: 8,
    href: _ctx.socials.juejin,
    target: "_blank",
    ref: "juejin"
  }, _cache[0] || (_cache[0] = [_createElementVNode("li", {
    class: "diamond-clip-path diamond-icon"
  }, "掘", -1 /* HOISTED */)]), 8 /* PROPS */, _hoisted_18)) : _createCommentVNode("v-if", true), _ctx.customSocials.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 9
  }, _renderList(_ctx.customSocials, social => {
    return _openBlock(), _createElementBlock("a", {
      key: social.name,
      href: social.link,
      target: "_blank",
      ref_for: true,
      ref: social.name
    }, [_createElementVNode("li", _hoisted_20, [social.icon.img_link ? (_openBlock(), _createBlock(_component_svg_icon, {
      key: 0,
      "icon-class": social.icon.img_link,
      class: "fill-current"
    }, null, 8 /* PROPS */, ["icon-class"])) : (_openBlock(), _createElementBlock("i", {
      key: 1,
      class: _normalizeClass(['custom-social-svg-icon', social.icon.iconfont])
    }, null, 2 /* CLASS */))])], 8 /* PROPS */, _hoisted_19);
  }), 128 /* KEYED_FRAGMENT */)) : _createCommentVNode("v-if", true)]);
}